"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ecommerce_1 = require("../../api/ecommerce");
const Button_1 = __importDefault(require("../../common/js/atoms/Button"));
const GlobalModal_1 = require("../../common/js/components/GlobalModal");
const ButtonVariant_1 = __importDefault(require("../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../common/js/enums/Zupicons"));
const array_1 = require("../../common/js/helper/array");
const string_1 = require("../../common/js/helper/string");
const translation_1 = require("../../common/js/helper/translation");
const ChangeRequestModal_1 = __importDefault(require("../components/ChangeRequestModal"));
const AddressDisplayTypes_1 = __importDefault(require("../enums/AddressDisplayTypes"));
const ContactContentClickTypes_1 = __importDefault(require("../enums/ContactContentClickTypes"));
const MassiveCompany_1 = __importDefault(require("../stores/MassiveCompany"));
const ContactLink_1 = __importDefault(require("./ContactLink"));
class UserProfileAddress extends react_1.default.Component {
    static isAddress(address) {
        return address.id !== undefined;
    }
    render() {
        const { className, title, address, showOnlyAddress, displayType = AddressDisplayTypes_1.default.full, editable = false, changeRequestObject, changeRequestTopic = ecommerce_1.ChangeRequestTopicEnum.Address, sendDataLayerContactValue, } = this.props;
        let additionalAddressLine;
        let company;
        let country;
        let countryCode;
        let countryStateCode;
        let department;
        let fax;
        let name;
        let phoneNumber1;
        let phoneNumber2;
        let role;
        let street;
        let website;
        let zip;
        if (UserProfileAddress.isAddress(address)) {
            name = address?.name1;
            street = (0, string_1.ensureNonEmptyStringOrUndefined)(address?.street);
            zip = address?.zipcode || address?.city ? (0, array_1.concat)([address?.zipcode, address?.city], ' ') : undefined;
            countryCode = address?.country?.iso;
            countryStateCode = address?.countryState?.shortCode
                ? address?.countryState?.shortCode.substring(3)
                : undefined;
            country = address?.country?.translated?.name;
            phoneNumber1 = (0, string_1.ensureNonEmptyStringOrUndefined)(address?.phoneNumber);
            if (displayType === AddressDisplayTypes_1.default.full) {
                company = address?.name2 || address?.name3 ? (0, array_1.concat)([address?.name2, address?.name3], ', ') : undefined;
                additionalAddressLine = (0, string_1.ensureNonEmptyStringOrUndefined)(address?.additionalAddressLine);
                fax = (0, string_1.ensureNonEmptyStringOrUndefined)(address?.fax);
                website = (0, string_1.ensureNonEmptyStringOrUndefined)(address?.website);
            }
        }
        else {
            name = address?.name;
            company = address?.company;
            phoneNumber1 = (0, string_1.ensureNonEmptyStringOrUndefined)(address?.phoneNumber1);
            phoneNumber2 = (0, string_1.ensureNonEmptyStringOrUndefined)(address?.phoneNumber2);
            department = address?.department;
            role = address?.role;
        }
        const email = address?.email && address?.email.trim().length > 0 ? address?.email : undefined;
        const changeRequestData = {
            additionalAddressLine: additionalAddressLine,
            city: UserProfileAddress.isAddress(address) ? address.city : undefined,
            countryCode: countryCode,
            countryStateCode: countryStateCode,
            department: department,
            email: address.email,
            externalId: address.externalId,
            fax: fax,
            name1: address.name1,
            name2: address.name2,
            phoneNumber1: phoneNumber1,
            phoneNumber2: phoneNumber2,
            role: role,
            salutation: UserProfileAddress.isAddress(address) ? undefined : address.salutation,
            street: street,
            taxId: UserProfileAddress.isAddress(address) ? address.taxId : undefined,
            website: website,
            zipCode: UserProfileAddress.isAddress(address) ? address.zipcode : undefined,
        };
        return (react_1.default.createElement("div", { className: className },
            title ? (react_1.default.createElement("div", { className: "znd-address__headline t-subhead-small" },
                title,
                editable ? (react_1.default.createElement(Button_1.default, { variant: ButtonVariant_1.default.text, text: (0, translation_1.t)('user.profile.edit'), iconRight: Zupicons_1.default.pen, className: "znd-address__button", onClick: () => {
                        (0, GlobalModal_1.showModal)({
                            component: ChangeRequestModal_1.default,
                            props: {
                                title: title,
                                edit: true,
                                topic: changeRequestTopic,
                                object: changeRequestObject,
                                data: changeRequestData,
                            },
                        }).then(() => {
                            MassiveCompany_1.default.loadCompany();
                        });
                    } })) : null)) : null,
            react_1.default.createElement("div", { className: "znd-address__details t-body" },
                name ? (react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { title: name }, name))) : null,
                react_1.default.createElement("div", null, [company, department]
                    .filter((value) => !!value)
                    .map((value, index) => (react_1.default.createElement("span", { title: value, key: value },
                    index === 0 ? null : ', ',
                    value)))),
                street ? (react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { title: street }, street))) : null,
                additionalAddressLine ? (react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { title: additionalAddressLine }, additionalAddressLine))) : null,
                react_1.default.createElement("div", null, [zip, countryStateCode]
                    .filter((value) => !!value)
                    .map((value, index) => (react_1.default.createElement("span", { title: value, key: value },
                    index === 0 ? null : ', ',
                    value)))),
                country ? (react_1.default.createElement("div", null,
                    react_1.default.createElement("span", { title: country }, country))) : null,
                !showOnlyAddress ? (react_1.default.createElement(react_1.default.Fragment, null,
                    phoneNumber1 ? (react_1.default.createElement(ContactLink_1.default, { dataLayerClickType: ContactContentClickTypes_1.default.phone, dataLayerTitle: title ?? '', href: `tel:${phoneNumber1}`, label: phoneNumber1, icon: Zupicons_1.default.phone, sendDataLayerLabel: sendDataLayerContactValue })) : null,
                    phoneNumber2 ? (react_1.default.createElement(ContactLink_1.default, { dataLayerClickType: ContactContentClickTypes_1.default.phone, dataLayerTitle: title ?? '', href: `tel:${phoneNumber2}`, label: phoneNumber2, icon: Zupicons_1.default.phone, sendDataLayerLabel: sendDataLayerContactValue })) : null,
                    fax ? (react_1.default.createElement(ContactLink_1.default, { dataLayerClickType: ContactContentClickTypes_1.default.fax, dataLayerTitle: title ?? '', href: `tel:${fax}`, label: fax, icon: Zupicons_1.default.fax })) : null,
                    website ? (react_1.default.createElement(ContactLink_1.default, { dataLayerClickType: ContactContentClickTypes_1.default.website, dataLayerTitle: title ?? '', href: website, label: website, icon: Zupicons_1.default.globe })) : null,
                    email ? (react_1.default.createElement(ContactLink_1.default, { dataLayerClickType: ContactContentClickTypes_1.default.email, dataLayerTitle: title ?? '', href: `mailto:${email}`, label: email, icon: Zupicons_1.default.envelope, sendDataLayerLabel: sendDataLayerContactValue })) : null)) : null)));
    }
}
exports.default = UserProfileAddress;
